import axios from "../../../../api/axios";
import { ExperienceResponse } from "../types/experience.types";

export const getUserExperience = async (userId: string): Promise<ExperienceResponse> => {
  try {
    const response = await axios.get<ExperienceResponse>(`users/${userId}/experience`);
    return response.data;
  } catch (err) {
    throw new Error(`Failed to fetch user experience: ${(err as Error).message}`);
  }
};
